<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapterNumber" id="_idParaDest-21">11</h1>
<p class="noindent">SUNDAY NEVER REALLY EXISTED FOR EDWARD EXETER. From time to time the pain in his leg would solidify out of the fog and he would open his eyes and see the mess of bandages and ropes and discover that he could not move. His head throbbed. He faded in and faded out. Often he would try to turn over and again be balked by those ropes and that leg stuck up in the air. He was vaguely aware of nurses coming around at intervals and talking to him. As soon as he grunted a few words, they would go away satisfied. Sometimes they tucked thermometers under his tongue and scolded when he went to sleep and dropped them. There was a nasty business with a bottle, too.</p>
<p class="normal">Often the world was filled with silent music, sometimes music soaring like a Puccini aria, sometimes funny music, like a Gilbert and Sullivan patter song, although he heard no words.</p>
<p class="normal">Once or twice he noted the drab brown walls and the stink of carbolic and ether. Then he would deduce yet again that he must be in a hospital and therefore was being cared for and could safely drift off again. At other times he thought he was back in Paris and reflected that Smedley’s uncle kept jolly hard beds. Once he had a memory of pain and streaming blood; he started to cry out then. Someone came and jabbed a needle in him and the music returned.</p>
<p class="normal"> </p>
<p class="noindent">A voice he knew spoke his name, very far away. His eyelids were heavy as coffin lids, but he forced them open and saw Alice.</p>
<p class="normal">“I’m dead, aren’t I?” His tongue was too thick, his lips too stiff.</p>
<p class="normal">“Not very.”</p>
<p class="normal">“Then why am I seeing angels?”</p>
<p class="normal">She squeezed his hand. “How do you feel?”</p>
<p class="normal">“Not quite as good as usual.”</p>
<p class="normal">“You’ll be better tomorrow, they say.”</p>
<p class="normal">He blinked to try and make his eyes work correctly. There was an electric light up there. “What time is it?”</p>
<p class="normal">“Evening. Sunday evening. You had a bang on the head. I told them there wasn’t much brain there to start with.”</p>
<p class="normal">He tried to say, “Tell me you love me and I’ll die happy.” He wasn’t sure if he managed to. They woke him later to give him a back rub, but Alice had gone.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PastImperative20.vue?58c50f38